import React, { Component } from "react";
import { Toast } from '../Notification';
import moment from 'moment';
import _ from 'underscore';
import ResourceDayTypesCalendarGeneralFrom from './ResourceDayTypesCalendarGeneralForm'
import blankResourceDayType from './utils/day-type-requests/blankResourceDayType';
import statusArray from './utils/day-type-requests/status';
import dayTypesArray from '../Schedule/utils/live-schedules/drop-down-tables/dayTypes';
import * as dayTypeActions from '../../redux/actions/dayTypeActions';
import * as resourceActions from '../../redux/actions/resourceActions';
import * as tourActions from '../../redux/actions/tourActions';
import { bindActionCreators } from "redux";
import { connect } from 'react-redux';
import AuthLogic from '../../AuthLogic/';


const timezone = 'UTC'; //Should be set to the timezone of the server, since amplify is on the cloud it uses UTC

class ResourceDayTypesCalendarUpdate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      contextMenuKey: this.props.contextMenuKey || false,
      selectedResourceDayType: this.props.selectedResourceDayType,
      selectedDates: this.props.selectedDates,
      resource: this.props.selectedResource,
      dayTypesAllowingTourScheduling: [],
    }
  }

  componentDidMount() {
    this.checkResource();
  }

  componentWillReceiveProps({ contextMenuKey, selectedResourceDayType, selectedDates }) {
    this.checkResource();
    this.setState({
      contextMenuKey,
      selectedResourceDayType,
      selectedDates
    });
  }

  checkResource = async () => {
    let resource;
    if (!this.state.resource.id && !this.state.resource.name) {
      resource = {
        id: this.props.user.login.resourceId,
        name: this.props.user.userDemographics.name
      }
      await this.setState({
        resource
      });
    }
  }

  clearForm = () => {
    this.setState({
      selectedResourceDayType: { ...blankResourceDayType }
    })
  }

  handleDayTypeChange = (value, callback) => {
    const { selectedResourceDayType } = this.state;
    selectedResourceDayType.dayTypeCode = value;

    this.setState({
      selectedResourceDayType
    }, () => { callback() });
  }

  handleDateChange = (value, callback) => {
    const { selectedResourceDayType } = this.state;
    selectedResourceDayType.date = value;

    this.setState({
      selectedResourceDayType
    }, () => { callback() });
  }

  handleCommentChange = (value, callback) => {
    const { selectedResourceDayType } = this.state;
    selectedResourceDayType.comment = value.target.value;;

    this.setState({
      selectedResourceDayType
    }, () => { callback() });
  }

  handleMyCommentChange = (value, callback) => {
    const { selectedResourceDayType } = this.state;
    selectedResourceDayType.myComment = value.target.value;;

    this.setState({
      selectedResourceDayType
    }, () => { callback() });
  }

  handleTKCommentChange = (value, callback) => {
    const { selectedResourceDayType } = this.state;
    selectedResourceDayType.TKComment = value.target.value;;

    this.setState({
      selectedResourceDayType
    }, () => { callback() });
  }

  createDayTypeRequest = async (formValues) => {
    this.props.handleModalCancel();

    //find the day type id for the request
    let foundDayType = this.props.dayTypesAll.find(dayType => dayType.dayTypeName === formValues.dayType);
    let dayTypeId;
    if (foundDayType) {
      dayTypeId = foundDayType.dayTypeId;
    } else {
      foundDayType = dayTypesArray.find(dayType => dayType.name === formValues.dayType);
      dayTypeId = foundDayType.id;
    }

    const parameters = {
      date: formValues.date.format('YYYY-MM-DD'),
      dayTypeId,
      resourceId: this.state.resource.id,
      comment: formValues.comment || " ",
      myComment: formValues.myComment || " ",
      TKComment: formValues.tkComment || " ",
      userId: this.props.user.login.id
    };

    let notification = { type: 'success', message: 'Day Type Request Added' };

    try {
      await this.props.actions.addResourceDayType(parameters);
    }
    catch (error) {
      if (!_.isEmpty(error)) {
        notification = {
          type: 'error',
          message: "Adding Day Type Request Failed",
          description: error.errors[0].message.includes('->') ? error.errors[0].message.split('->')[1] : error.errors[0].message
        };
      }
    }
    Toast(notification);
    if (notification.type !== 'error') {
      this.clearForm();
      this.props.readyApiCall();
    }
  }

  createMultipleDayTypeRequests = async (formValues) => {
    this.props.handleModalCancel();

    //find the day type id for the request
    let foundDayType = this.props.dayTypesAll.find(dayType => dayType.dayTypeName === formValues.dayType);
    let dayTypeId;
    if (foundDayType) {
      dayTypeId = foundDayType.dayTypeId;
    } else {
      foundDayType = dayTypesArray.find(dayType => dayType.name === formValues.dayType);
      dayTypeId = foundDayType.id;
    }

    this.state.selectedDates.forEach(async (date, index) => {

      const parameters = {
        date,
        dayTypeId,
        resourceId: this.state.resource.id,
        comment: formValues.comment || " ",
        myComment: formValues.myComment || " ",
        TKComment: formValues.tkComment || " ",
        userId: this.props.user.login.id
      };

      let notification = { type: 'success', message: 'Day Type Request Added' };

      try {
        await this.props.actions.addResourceDayType(parameters);
      }
      catch (error) {
        if (!_.isEmpty(error)) {
          notification = {
            type: 'error',
            message: "Adding Day Type Request Failed",
            description: error.errors[0].message.includes('->') ? error.errors[0].message.split('->')[1] : error.errors[0].message
          };
        }
      }
      Toast(notification);
      if (notification.type !== 'error') {
        this.clearForm();
        if (index === this.state.selectedDates.length - 1) {
          this.props.readyApiCall();
        }
      }
    });
  }

  updateDayTypeRequest = async (formValues, resourceDayType) => {
    this.props.handleModalCancel();

    let foundDayType = this.props.dayTypesAll.find(dayType => dayType.dayTypeName === formValues.dayType);
    let dayTypeId;
    if (foundDayType) {
      dayTypeId = foundDayType.dayTypeId;
    } else {
      foundDayType = dayTypesArray.find(dayType => dayType.name === formValues.dayType);
      dayTypeId = foundDayType.id;
    }

    const parameters = {
      date: formValues.date.format('YYYY-MM-DD'),
      dayTypeId: dayTypeId,
      resourceId: this.state.resource.id,
      approved: resourceDayType.approved,
      comment: formValues.comment || " ",
      myComment: formValues.myComment || " ",
      daysRequestId: resourceDayType.daysRequestId,
      userId: this.props.user.login.id,
      unionId: resourceDayType.unionId,
      contractId: resourceDayType.contractId,
      contractRulesGroupId: resourceDayType.contractRulesGroupId,
      salaryLevelId: resourceDayType.salaryLevelId,
      IPAddress: resourceDayType.ipAddress,
      TKComment: resourceDayType.TKComment || " ",
      jobSalaryId: resourceDayType.jobSalaryId,
      hourlyActivityRateFlag: resourceDayType.hourlyActivityRateFlag,
      rate: resourceDayType.rate,
      resourceDayTypeId: resourceDayType.resourceDayTypeId
    };

    let notification = { type: 'success', message: 'Day Type Request Updated' };

    try {
      await this.props.actions.editResourceDayType(parameters);
    }
    catch (error) {
      if (!_.isEmpty(error)) {
        notification = {
          type: 'error',
          message: "Updating Day Type Request Failed",
          description: error.errors[0].message.includes('->') ? error.errors[0].message.split('->')[1] : error.errors[0].message
        };
      }
    }
    Toast(notification);
    if (notification.type !== 'error') {
      this.clearForm();
      this.props.readyApiCall();
    }
  }

  deleteDayTypeRequest = async (resourceDayTypeId) => {
    this.props.handleModalCancel();

    let notification = { type: 'success', message: 'Day Type Request Removed' };

    let parameters = {
      id: resourceDayTypeId,
      updatingUserId: this.props.user.login.id
    };

    try {
      await this.props.actions.removeResourceDayType(parameters);
    }
    catch (error) {
      if (!_.isEmpty(error)) {
        notification = {
          type: 'error',
          message: "Removing Day Type Request Failed",
          description: error.errors[0].message.includes('->') ? error.errors[0].message.split('->')[1] : error.errors[0].message
        };
      }
    }
    Toast(notification);
    if (notification.type !== 'error') {
      this.clearForm();
      this.props.readyApiCall();
    }
  }

  checkIfTourExists = async (values) => {

    let parameters = {
      resourceId: this.state.resource.id || this.props.user.login.resourceId,
      fromDate: values.fromDate.startOf('day').format('DD MMM YYYY HH:mm:ss ') + timezone,
      toDate: values.toDate.startOf('day').format('DD MMM YYYY HH:mm:ss ') + timezone
    }

    await this.props.actions.fetchIfToursAreInDateRange(parameters);

    return this.props.ifToursAreInDateRange;
  }

  getDayTypesAllowingTourScheduling = async (selectedDates) => {

    let values = {};
    let toursInRange = [];

    for (let date of selectedDates) {
      values = {
        fromDate: moment(date),
        toDate: moment(date)
      }
      // based on this we set with force tour
      toursInRange.push(await this.checkIfTourExists(values));
    }

    let hasTour = false;
    for (let tourInfo of toursInRange) {
      if (tourInfo.tourCounter > 0) {
        hasTour = true;
      }
    }

    if (!this.state.resource || !this.state.resource.id) {
      return
    }

    const params = {
      resourceId: parseInt(this.state.resource.id),
      isApprover: AuthLogic.isApprover(this.props.user),
      date: moment(this.state.selectedResourceDayType.date).format('YYYY-MM-DD hh:mm:ss'),
      dayTypeId: this.state.selectedResourceDayType.resourceDayTypeId,
      withForceTour: hasTour
    };

    if (this.state.selectedResourceDayType.resourceDayTypeId) {
      await this.props.actions.fetchDayTypesAllowingTourScheduling(params);
      this.setState({
        dayTypesAllowingTourScheduling: this.props.dayTypesAllowingTourScheduling
      });
    } else {
      this.setState({
        dayTypesAllowingTourScheduling: []
      });
    }
  }

  render() {
    return (
      <ResourceDayTypesCalendarGeneralFrom
        user={this.props.user}
        resource={this.state.resource}
        resourceDayTypeDetails={this.state.selectedResourceDayType}
        contextMenuKey={this.state.contextMenuKey}
        selectedDates={this.state.selectedDates}
        dayTypesAllWithoutForceTour={this.props.dayTypesAllWithoutForceTour}
        dayTypesAllowingTourScheduling={this.state.dayTypesAllowingTourScheduling}
        getDayTypesAllowingTourScheduling={this.getDayTypesAllowingTourScheduling}
        createDayTypeRequest={this.createDayTypeRequest}
        createMultipleDayTypeRequests={this.createMultipleDayTypeRequests}
        updateDayTypeRequest={this.updateDayTypeRequest}
        deleteDayTypeRequest={this.deleteDayTypeRequest}
        checkIfTourExists={this.checkIfTourExists}
        handleDayTypeChange={this.handleDayTypeChange}
        handleDateChange={this.handleDateChange}
        handleCommentChange={this.handleCommentChange}
        handleMyCommentChange={this.handleMyCommentChange}
        handleTKCommentChange={this.handleTKCommentChange}
      />
    )
  }
}

function mapStateToProps(state) {
  return {
    user: state.user,
    resources: state.resources,
    selectedResource: state.selectedResource,
    dayTypesAll: state.dayTypesAll.dayTypes,
    dayTypesAllowingTourScheduling: state.dayTypesAllowingTourScheduling.dayTypes,
    dayTypesAllWithoutForceTour: state.dayTypesAllWithoutForceTour.dayTypes,
    ifToursAreInDateRange: state.ifToursAreInDateRange.data[0],
    ifHasHolidaySchedule: state.ifHasHolidaySchedule
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: {
      fetchDayTypesAllowingTourScheduling: bindActionCreators(
        dayTypeActions.fetchDayTypesAllowingTourScheduling,
        dispatch
      ),
      addResourceDayType: bindActionCreators(
        dayTypeActions.addResourceDayType,
        dispatch
      ),
      editResourceDayType: bindActionCreators(
        dayTypeActions.editResourceDayType,
        dispatch
      ),
      removeResourceDayType: bindActionCreators(
        dayTypeActions.removeResourceDayType,
        dispatch
      ),
      updateSelectedResource: bindActionCreators(
        resourceActions.updateSelectedResource,
        dispatch
      ),
      fetchIfToursAreInDateRange: bindActionCreators(
        tourActions.fetchIfToursAreInDateRange,
        dispatch
      ),
      fetchIfHasHolidaySchedule: bindActionCreators(
        dayTypeActions.fetchIfHasHolidaySchedule,
        dispatch
      ),
    }
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ResourceDayTypesCalendarUpdate);


// WEBPACK FOOTER //
// ./src/Components/DayType/ResourceDayTypesCalendarUpdate.js